import type { Asset, AssetPhoto } from '@/types/asset';

/**
 * Get the primary photo URL for an asset.
 * Returns the URL of the primary photo, or the first photo if no primary is set,
 * or undefined if no photos exist.
 */
export function getAssetPrimaryPhotoUrl(asset: Pick<Asset, 'photos'>): string | undefined {
  if (!asset.photos || asset.photos.length === 0) {
    return undefined;
  }
  const primaryPhoto = asset.photos.find(p => p.isPrimary);
  return primaryPhoto?.url ?? asset.photos[0]?.url;
}

/**
 * Get the primary photo object for an asset.
 * Returns the primary photo, or the first photo if no primary is set,
 * or undefined if no photos exist.
 */
export function getAssetPrimaryPhoto(asset: Pick<Asset, 'photos'>): AssetPhoto | undefined {
  if (!asset.photos || asset.photos.length === 0) {
    return undefined;
  }
  return asset.photos.find(p => p.isPrimary) ?? asset.photos[0];
}
